import cn from "classnames";
import { formatDateTimezone, isStartBidPoint } from "helpers/bidpoint";
import { dateTimeToView, humanizedTimeDiff } from "helpers/date";
import { bidStatusesEnum } from "helpers/enums";
import { pointLetter } from "helpers/system";
import { divIcon } from "leaflet";
import React from "react";
import { Marker, Tooltip } from "react-leaflet";

const BidPoint = React.memo((props) => {
    const { item, index, bid, firstLoadPointIndex } = props;
    if (isStartBidPoint(item.geozone.type)) {
        return null;
    }

    const isActive = [bidStatusesEnum.Started, bidStatusesEnum.Done].includes(bid.status);

    // decide which date to use, auto dates in the priority
    const factOrAutoEnteredAt = item.enteredAtByLogist || item.autoEnteredAt || item.enteredAt;
    const factOrAutoLeftAt = item.enteredAtByLogist || item.autoLeavedAt || item.loadUnloadedAt;

    const enterLatePeriod = humanizedTimeDiff(item.planEnterDateOffset, factOrAutoEnteredAt);
    const leaveLatePeriod = humanizedTimeDiff(item.planLeaveDateOffset, factOrAutoLeftAt);

    const enteredOnTime = enterLatePeriod && enterLatePeriod.charAt(0) !== "-";
    const leftOnTime = leaveLatePeriod && leaveLatePeriod.charAt(0) !== "-";

    const enteredLate = enterLatePeriod && enterLatePeriod.charAt(0) === "-";
    const leftLate = leaveLatePeriod && leaveLatePeriod.charAt(0) === "-";

    const isLate = enteredLate || leftLate;
    const isOnTime = enteredOnTime || leftOnTime;

    const utcTimezone = formatDateTimezone(item);
    const { city, village, county, address } = item.geozone;

    const className = cn("route-icon", {
        "route-icon--late": isActive && isLate,
        "route-icon--schedule": isActive && isOnTime,
    });

    const coordinates = Array.isArray(item.geozone.location)
        ? item.geozone.location
        : item.geozone.location?.coordinates;
    const inverted = [coordinates[1], coordinates[0]];
    const options = {
        id: item.id,
        position: inverted,
        icon: divIcon({ className, iconSize: [30, 30], html: pointLetter(index, firstLoadPointIndex) }),
        pointType: item.type,
        zIndexOffset: 1000,
    };

    return (
        <Marker {...options}>
            <Tooltip className="map__point-tooltip leaflet-tooltip--left-align leaflet-tooltip--light" direction="top">
                <div className="route-icon__time-tooltip--header pb-1">
                    <span className="b-timeline-point__city--name">{city || village || county}</span>
                    <small className="text-muted">&nbsp;{utcTimezone}</small>
                </div>
                <div className="b-timeline-point__city--full pb-2">{address}</div>
                <div className="route-icon__time-tooltip">
                    <div />
                    <div className="font-weight-bold">Въезд</div>
                    <div className="font-weight-bold">Выезд</div>
                    <div className="font-weight-bold">План</div>
                    <div>
                        {dateTimeToView(item.planEnterDateOffset || item.planEnterDate)}
                        {(item.secondaryPlanEnterDateOffset || item.secondaryPlanEnterDate) && (
                            <>
                                <br />
                                {dateTimeToView(item.secondaryPlanEnterDateOffset || item.secondaryPlanEnterDate)}
                            </>
                        )}
                    </div>
                    <div>{dateTimeToView(item.planLeaveDateOffset)}</div>
                    {item.planLeaveDateOffset ? (
                        <>
                            <div className="font-weight-bold">Факт</div>
                            {!!factOrAutoEnteredAt && enterLatePeriod && enterLatePeriod !== "0" ? (
                                <div>
                                    {dateTimeToView(factOrAutoEnteredAt)}
                                    <br />
                                    <span
                                        className={cn("route-icon__time-tooltip--small-text", {
                                            "text-danger": enteredLate,
                                            "text-success": !enteredLate,
                                        })}
                                    >
                                        ({enterLatePeriod.slice(enteredLate ? 1 : 0)})
                                    </span>
                                </div>
                            ) : (
                                <div />
                            )}
                        </>
                    ) : (
                        <div />
                    )}
                    {!!factOrAutoLeftAt && leaveLatePeriod && leaveLatePeriod !== "0" ? (
                        <div>
                            {dateTimeToView(factOrAutoLeftAt)}
                            <br />
                            <span
                                className={cn("route-icon__time-tooltip--small-text", {
                                    "text-danger": leftLate,
                                    "text-success": !leftLate,
                                })}
                            >
                                ({leaveLatePeriod.slice(leftLate ? 1 : 0)})
                            </span>
                        </div>
                    ) : (
                        <div />
                    )}
                </div>
            </Tooltip>
        </Marker>
    );
});

export default BidPoint;
